export const EmbedSettingNames = {
  embeddingContainerClassName: 'uc-embed',
  embeddingOptionsAttributeName: 'uc-data',
  embeddingServiceAttributeName: 'uc-consent-name',
  embeddingShowAllOptions: 'all',
  embeddingShowAllServices: 'all',
  embeddingShowToggle: 'uc-show-toggle',
  embeddingStyle: 'uc-embedding-type',
  embeddingTitle: 'uc-embedding-title',
  embeddingUseStyling: 'uc-styling',
};

const Color = {
  blue: '#0045A5',
  lightGray: '#dedede',
  off: '#595959',
  white: '#ffffff',
};

export const Classnames = {
  dataCollected: 'uc-dataCollected',
  dataProtectionOfficer: 'uc-dataProtectionOfficer',
  dataPurposes: 'uc-dataPurposes',
  dataRecipients: 'uc-dataRecipients',
  description: 'uc-description',
  furtherInformation: 'uc-furtherInformation',
  legalBasis: 'uc-legalBasis',
  optInCheckboxWithLabel: 'uc-optInCheckboxWithLabel',
  processingLocation: 'uc-processingLocation',
  processorNames: 'uc-processorNames',
  retentionPeriod: 'uc-retentionPeriod',
  technologiesUsed: 'uc-technologiesUsed',
  thirdCountryTransfer: 'uc-thirdCountryTransfer',
  toggleButton: 'uc-embed-toggle-button',
};

export const Styles = {
  toggleButton: {
    style: `display: flex; justify-content: center; align-items: center; background: none; border: none; height: 20px; width: 40px; min-height: 20px; min-width: 40px; outline: none; padding: 0`,
  },
};

export const getDisabledIcon = (): HTMLElement => {
  const html = `<svg width="42px" height="23px" viewBox="0 0 42 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g transform="translate(-86.000000, -31.000000)">
      <g transform="translate(87.000000, 32.949632)">
        <path
          d="M30.0094932,-0.5 C32.8534346,-0.5 35.4330697,0.632406246 37.3226603,2.47154687 C39.2173227,4.31562389 40.4181217,6.87029149 40.4959736,9.70631513 C40.4981622,12.7440885 39.3375699,15.4233885 37.4620437,17.3539966 C35.5609243,19.3109495 32.9241909,20.5 30.0094932,20.5 L30.0094932,20.5 L9.99050677,20.5 C7.14626154,20.5 4.56639324,19.3679366 2.67675543,17.5287725 C0.782448937,15.6850644 -0.418130086,13.1306858 -0.49597372,10.2937978 C-0.498162151,7.25597731 0.662425032,4.576654 2.53794226,2.64603293 C4.43906304,0.689056047 7.07580212,-0.5 9.99050677,-0.5 L9.99050677,-0.5 Z"
          stroke="${Color.white}"
          fill="${Color.lightGray}"
        />
        <path
          d="M30,18 C34.418278,18 38,14.418278 38,10 C38,5.581722 34.418278,2 30,2 C25.581722,2 22,5.581722 22,10 C22,14.418278 25.581722,18 30,18 Z"
          fill="${Color.white}"
        />
        <path
          d="M15.8228065,6.13470278 C16.038065,6.32450074 16.0587048,6.65286384 15.8689068,6.8681223 C15.8665182,6.87083131 15.8641014,6.87351535 15.8616569,6.87617398 L9.47642761,13.8205455 C9.39995063,13.9037194 9.30336409,13.9576046 9.20086748,13.9814572 C9.01166585,14.0332136 8.80114396,13.9796182 8.65955286,13.8256282 L8.65955286,13.8256282 L6.13834311,11.083641 L6.13834311,11.083641 L6.13109318,11.0755893 C5.94129522,10.8603308 5.96193502,10.5319677 6.17719348,10.3421698 C6.39831738,10.1472001 6.73475108,10.164828 6.93428873,10.3818388 L6.93428873,10.3818388 L9.06521734,12.6992981 L15.0657113,6.17437179 C15.2652489,5.95736102 15.6016826,5.93973313 15.8228065,6.13470278 Z"
          fill="${Color.white}"
        />
      </g>
    </g>
  </g>
</svg>`;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'image/svg+xml');

  return doc.documentElement;
};

export const getOnIcon = (): HTMLElement => {
  const html = `<svg width="100%" height="100%" viewBox="0 0 42 22" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
      <path
        d="M0 11C0 4.925 4.92 0 11.008 0h19.984C37.072 0 42 4.924 42 11c0 6.075-4.92 11-11.008 11H11.008C4.928 22 0 17.08 0 11z"
        fill="${Color.blue}"
      />
      <path d="M31 20a9 9 0 100-18 9 9 0 000 18z" fill="white" />
      <path d="M8 6h10v10H8z" />
      <path
        d="M17.225 7.671c.192.173.208.47.035.662l-5.59 6.209a.467.467 0 01-.202.131l-.02.006a.467.467 0 01-.492-.133l-2.209-2.452a.469.469 0 01.697-.627l1.866 2.072 5.253-5.833a.469.469 0 01.662-.035z"
        fill="${Color.white}"
      />
    </g>
  </svg>`;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'image/svg+xml');

  return doc.documentElement;
};

export const getOffIcon = (): HTMLElement => {
  const html = `<svg width="100%" height="100%" viewBox="0 0 42 22" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
      <path
        d="M0 11C0 4.925 4.92 0 11.008 0h19.984C37.072 0 42 4.924 42 11c0 6.075-4.92 11-11.008 11H11.008C4.928 22 0 17.08 0 11z"
        fill="${Color.off}"
      />
      <path d="M11 20a9 9 0 100-18 9 9 0 000 18z" fill="white" />
      <path
        d="M29.725 11.204l3.318-3.315a.51.51 0 10-.724-.724L29 10.48l-3.319-3.315a.51.51 0 10-.724.724l3.318 3.315-3.318 3.317a.51.51 0 10.724.723L29 11.928l3.319 3.317a.509.509 0 00.724 0c.2-.2.2-.525 0-.724l-3.318-3.317z"
        fill="${Color.white}"
        fillRule="nonzero"
      />
    </g>
  </svg>`;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'image/svg+xml');

  return doc.documentElement;
};
